import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
const IFRAME_STYLES = {
  border: 0,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '3px'
};
const EMBED_CARD_STYLES = {
  padding: '10px',
  background: '#ccc',
  borderRadius: '3px'
};
const EMBED_CARD_LAYOUT_STYLES = {
  center: {
    margin: '0 auto'
  },
  left: {
    margin: '0 auto 0 0'
  },
  right: {
    margin: '0 0 0 auto'
  }
};
const IframeComponent = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    url
  } = _ref;
  return /*#__PURE__*/React.createElement("iframe", {
    allowFullScreen: true,
    title: title,
    src: url,
    style: IFRAME_STYLES,
    scrolling: "yes",
    allow: "autoplay; encrypted-media; clipboard-write"
  });
});
IframeComponent.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string
};
IframeComponent.defaultProps = {
  url: '',
  title: ''
};
const EmbedCardView = _ref2 => {
  let {
    url,
    width,
    height,
    title,
    wrapType,
    layout,
    view
  } = _ref2;
  const wrapperStyles = useMemo(() => _objectSpread(_objectSpread({}, EMBED_CARD_STYLES), {}, {
    width,
    height
  }, EMBED_CARD_LAYOUT_STYLES[layout || 'center']), [width, height, layout]);
  const onClick = useCallback(e => {
    if (view !== null && view !== void 0 && view.editable) {
      e.preventDefault();
    }
  }, [view]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, wrapType === 'inline' ? /*#__PURE__*/React.createElement("a", {
    className: "tap-editor-embedcard-inline",
    href: url,
    title: title,
    onClick: onClick
  }, url) : /*#__PURE__*/React.createElement("div", {
    className: "tap-editor-embedcard",
    style: wrapperStyles
  }, /*#__PURE__*/React.createElement(IframeComponent, {
    title: title,
    url: url
  })));
};
EmbedCardView.propTypes = {
  view: PropTypes.object.isRequired,
  url: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  title: PropTypes.string,
  wrapType: PropTypes.string,
  layout: PropTypes.string
};
EmbedCardView.defaultProps = {
  url: '',
  width: '',
  height: '',
  title: '',
  wrapType: '',
  layout: ''
};
export default /*#__PURE__*/React.memo(EmbedCardView);